import { HeaderData } from './header-data.interface';

export enum HeaderType {
  DEFAULT = 'default',
  SESSION_FORM = 'session-form',
  SESSION_VIEW = 'session-view',
  DISCUSSION = 'discussion',
}

export enum HeaderTab {
  GENERAL = 'general',
  TEAMS = 'teams',
  PEOPLE = 'people',
  CONTENT = 'content',
  LOG = 'LOG',
  VOTE_TEAM = 'VOTE_TEAM',
  VOTE_ALL = 'VOTE_ALL',
  FORUM = 'FORUM',
  CHAT = 'CHAT',
}

export class HeaderTypeRequest {
  type: HeaderType;
  tab?: HeaderTab;
  data?: HeaderData;
}
